/* Check for encryptedCard if present it's for enrollment else
* regular checkout flow. Also check for srcDigitalCardId for checkout flow
*/
const isEnrollCard = data => 'encryptedCard' in data && !data.srcDigitalCardId;

export default isEnrollCard;
